import '../../Styles/LoginPage/Login.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopyright } from '@fortawesome/free-regular-svg-icons';
import { faHardHat, faCogs, faAddressBook, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import LogoCoordo from '../../Styles/Pictures/logo_coordogec.jpg';
import React from 'react';
import SocialNetwork from './SocialNetwork.js';
import RegisterForm from './RegisterForm.js';

const FEATURES = [
  { icon: faHardHat, title: 'Suivi Chantier', desc: 'Gestion en temps réel de vos projets' },
  { icon: faCogs, title: 'Process Coordogec', desc: 'Optimisation de vos workflows' },
  { icon: faAddressBook, title: 'Contacts', desc: 'Centralisez partenaires et clients' },
  { icon: faFileInvoiceDollar, title: 'Facturation', desc: 'Devis et factures en un clic' },
];

function Register() {
  return (
    <div className="lp-root">

      <aside className="lp-brand">
        <div className="lp-brand__grid" aria-hidden="true" />
        <div className="lp-brand__glow" aria-hidden="true" />

        <div className="lp-brand__body">

          <div className="lp-brand__headline">
            <span className="lp-brand__eyebrow">système d'exploitation et coordination sec</span>
            <h1 className="lp-brand__name">
              Coordogec<em className="lp-brand__erp"> ERP</em>
            </h1>
            <p className="lp-brand__desc">
              Pilotez vos chantiers, processus et finances depuis une seule plateforme unifiée.
            </p>
          </div>

          <ul className="lp-features" aria-label="Fonctionnalités">
            {FEATURES.map(({ icon, title, desc }, i) => (
              <li key={title} className="lp-features__item" style={{ animationDelay: `${0.15 + i * 0.08}s` }}>
                <span className="lp-features__icon" aria-hidden="true">
                  <FontAwesomeIcon icon={icon} />
                </span>
                <div className="lp-features__text">
                  <strong>{title}</strong>
                  <p>{desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <footer className="lp-brand__footer">
          <SocialNetwork />
          <span className="lp-copyright">
            <FontAwesomeIcon icon={faCopyright} />
            {' '}Coordogec, {new Date().getFullYear()} — Tous droits réservés
          </span>
        </footer>
      </aside>

      <main className="lp-auth lp-auth--scroll">
        <div className="lp-auth__inner">
          <div className="lp-auth__header">
            <div className="lp-brand__logo-wrap">
              <img src={LogoCoordo} alt="Coordogec" className="lp-brand__logo" />
            </div>
            <h2 className="lp-auth__title">Créer un compte</h2>
            <p className="lp-auth__sub">Rejoignez l'écosystème Coordogec</p>
          </div>
          <RegisterForm />
        </div>
      </main>

    </div>
  );
}

export default Register;
